<template>
  <div class="blog-entry-container pt-4">
    <h1>{{ post.title }}</h1>
    <hr />

    <p>
      <b-badge variant="accent">{{ post.category }}</b-badge> {{ post.date }}
    </p>

    <h2>What to pack to look your best on vacation</h2>
    <p>
      We’re continuing our Capsule Wardrobe series this month with a focus on
      summer vacation and travel. While a summer vacation is most certainly
      about rest and relaxation, that doesn’t mean your style needs to take a
      vacation as well. There are definitely ways to keep it relaxed and stay
      tailored and dapper at the same time. And that’s what the 10 pieces in our
      July collection are all about.
    </p>

    <BlogCapsule :capsule="currentCapsule" v-if="!loadingData" />

    <p>Here are the 10 pieces:</p>
    <ul>
      <li>Cream linen blazer</li>
      <li>Pattered blazer</li>
      <li>Lightweight light blue denim shirt</li>
      <li>Black polo shirt</li>
      <li>Printed shirt</li>
      <li>Khaki linen pants</li>
      <li>Stone/white cotton pants</li>
      <li>Panama hat</li>
      <li>Brown horse bit loafers</li>
      <li>Black espadrilles</li>
    </ul>
    <p>And here are several ways to style them.</p>

    <h2>Airport Ready</h2>

    <BlogOutfit :outfit="outfitById(43)" v-if="!loadingData" />

    <p>
      There are a few key things to keep in mind when considering your airport
      style. Be sure to wear a pair of loafers. They’re easy to slip on and off,
      which makes traveling through the security line that much easier. If you
      are bringing two blazers on your trip, wear one to the airport to save it
      from getting wrinkled in your suitcase. (Remember, even if you know how to
      pack it, wrinkles are unavoidable.) When you get on the plane, simply
      remove it, fold it once lengthwise and then in half again and stow in the
      overhead compartment. And if you plan to bring a hat, it is best to wear
      it to the airport rather than pack it in a bag.
    </p>

    <h2>Resort Dinner</h2>

    <BlogOutfit :outfit="outfitById(44)" v-if="!loadingData" />

    <p>
      A nice dinner at your resort is the time to break out your best sport
      coat. Keep it casual with a lightweight denim shirt and cotton trousers
      and finish the look off with a fun pair of loafers.
    </p>

    <h2>Day Trippin</h2>

    <BlogOutfit :outfit="outfitById(45)" v-if="!loadingData" />

    <p>
      Comfort and style do not have to be mutually exclusive. A short sleeve
      printed shirt and linen pants will keep you cool in both the looks and
      temperature departments. Espadrilles are a great utility shoe and a hat
      will save your face from the sun’s rays.
    </p>

    <h2>Island Cocktails</h2>

    <BlogOutfit :outfit="outfitById(46)" v-if="!loadingData" />

    <p>
      A few tweaks make the last look more appropriate for sunset cocktails.
      Throw on your sport coat and swap your linen trousers for a more
      structured cotton pair with a cuff.
    </p>

    <h2>Pool Lounging</h2>

    <BlogOutfit :outfit="outfitById(47)" v-if="!loadingData" />

    <p>
      Never underestimate the power of a simple polo shirt. Focus on a few
      accessories to kick it up a notch. And if it gets a little warmer, roll up
      your pant legs and dip your feet in the pool.
    </p>

    <h2>Return Flight</h2>

    <BlogOutfit :outfit="outfitById(48)" v-if="!loadingData" />

    <p>
      Wear linen and cotton to keep those vacation vibes going on your way home.
    </p>
  </div>
</template>

<script>
import BlogCapsule from "@/components/blogEntry/BlogCapsule.vue";
import BlogOutfit from "@/components/blogEntry/BlogOutfit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  created() {
    this.fetchData();
  },

  data() {
    return {
      capsuleId: 19,
      loadingData: true
    };
  },

  props: {
    post: {
      type: Object,
      required: true
    }
  },

  components: {
    BlogCapsule,
    BlogOutfit
  },

  computed: {
    ...mapGetters(["currentCapsule", "allOutfitsWithLayers"])
  },

  methods: {
    ...mapActions(["fetchCurrentCapsule", "fetchOutfitsWithLayers"]),

    fetchData() {
      this.fetchCurrentCapsule({ capsuleId: this.capsuleId }).then(response => {
        this.fetchOutfitsWithLayers(this.capsuleId).then(response => {
          this.loadingData = false;
        });
      });
    },

    outfitById(id) {
      if (this.allOutfitsWithLayers) {
        return this.$lodash.find(this.allOutfitsWithLayers, ["id", id]);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/blogEntry/posts/travel-in-style-this-summer-with-our-july-capsule-wardrobe.vue